var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "c-post-click o-grid o-grid--no-margin o-grid--center u-width-8/12 u-width-10/12@l u-width-full@m",
    },
    [
      _vm.post.network_id !== _vm.$simpleStore.Networks.DY &&
      (_vm.post.thumbnail ||
        (_vm.post.uri && _vm.post.network_id === _vm.$simpleStore.Networks.IN))
        ? _c(
            "div",
            {
              staticClass:
                "c-article__banner o-grid__item u-width-full c-post__mid",
            },
            [
              _vm.post.network_id === _vm.$simpleStore.Networks.YT
                ? _c(
                    "div",
                    { staticClass: "c-video-wrapper" },
                    [
                      _c("youtube", {
                        ref: "youtube",
                        attrs: {
                          "video-id": _vm.post.video_id,
                          "player-vars": _vm.youtubeConfig,
                          width: "1024",
                          height: "576",
                          resize: "true",
                        },
                        on: { playing: _vm.playing },
                      }),
                    ],
                    1
                  )
                : _vm.post.network_id === _vm.$simpleStore.Networks.FB &&
                  _vm.post.type != null &&
                  _vm.post.type.indexOf("video") !== -1
                ? _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.post.source) },
                  })
                : _vm.post.network_id === _vm.$simpleStore.Networks.FB &&
                  _vm.post.type === "album" &&
                  typeof _vm.post.media_attachments === "object"
                ? _c(
                    "div",
                    { ref: "fbSlides" },
                    [
                      _c(
                        "VueSlickCarousel",
                        {
                          attrs: {
                            adaptiveHeight: true,
                            arrows: true,
                            autoplay: false,
                            autoplaySpeed: 2500,
                            draggable: false,
                            infinite: false,
                          },
                        },
                        _vm._l(
                          _vm.post.media_attachments,
                          function (slide, index) {
                            return _c("img", {
                              attrs: {
                                src: slide.src,
                                alt: "slide",
                                id: "slide-" + index,
                              },
                              on: {
                                error: (event) =>
                                  _vm.updateSlide(event, _vm.post),
                              },
                            })
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  )
                : _vm.post.network_id === _vm.$simpleStore.Networks.IN &&
                  _vm.post.type === "carousel_album" &&
                  _vm.post.media_attachments &&
                  typeof _vm.post.media_attachments === "object"
                ? _c(
                    "div",
                    { ref: "inSlides" },
                    [
                      _c(
                        "VueSlickCarousel",
                        {
                          attrs: {
                            adaptiveHeight: true,
                            arrows: true,
                            autoplay: false,
                            autoplaySpeed: 2500,
                            draggable: false,
                            infinite: false,
                          },
                        },
                        _vm._l(
                          _vm.post.media_attachments,
                          function (slide, index) {
                            return _c("img", {
                              attrs: {
                                src: slide.src,
                                alt: "slide",
                                id: "slide-" + index,
                              },
                            })
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  )
                : _vm.post.network_id === _vm.$simpleStore.Networks.TW &&
                  typeof _vm.post.videoData != "undefined"
                ? _c(
                    "video",
                    {
                      attrs: {
                        width: _vm.post.media_width,
                        poster: _vm.post.videoData.thumbnailUrl,
                        controls: "",
                      },
                    },
                    [
                      _c("source", {
                        attrs: {
                          src: _vm.post.videoData.videoUrl,
                          type: "video/mp4",
                        },
                      }),
                    ]
                  )
                : _vm.post.network_id === _vm.$simpleStore.Networks.IN &&
                  _vm.post.type !== "video"
                ? _c("img", {
                    attrs: {
                      src: _vm.post.uri,
                      alt: _vm.post.community_name + " article image",
                    },
                  })
                : _vm.post.network_id === _vm.$simpleStore.Networks.IN &&
                  _vm.post.type === "video"
                ? _c(
                    "video",
                    { attrs: { width: _vm.post.media_width, controls: "" } },
                    [
                      _c("source", {
                        attrs: { src: _vm.post.uri, type: "video/mp4" },
                      }),
                    ]
                  )
                : _c("img", {
                    attrs: {
                      src: _vm.post.thumbnail,
                      alt: _vm.post.community_name + " article image",
                    },
                  }),
            ]
          )
        : _vm.post.network_id === _vm.$simpleStore.Networks.DY &&
          (_vm.post.thumbnail || _vm.post.youtube_id || _vm.post.media)
        ? _c(
            "div",
            {
              staticClass:
                "c-post-click c-article__banner o-grid__item u-width-full c-post__mid",
              staticStyle: { "min-height": "250px" },
            },
            [
              _vm.post.thumbnail
                ? [
                    _c(
                      "figure",
                      { staticClass: "image", attrs: { id: "thumbnail" } },
                      [
                        _c("img", {
                          class: _vm.post.hero_size,
                          attrs: {
                            src: _vm.post.thumbnail,
                            alt: _vm.post.community_name + " article image",
                          },
                        }),
                      ]
                    ),
                  ]
                : _vm.post.youtube_id
                ? [
                    _c(
                      "div",
                      { staticClass: "c-video-wrapper" },
                      [
                        _c("youtube", {
                          ref: "youtube",
                          attrs: {
                            "video-id": _vm.post.youtube_id,
                            "player-vars": _vm.youtubeConfig,
                            width: "1024",
                            height: "576",
                            resize: "true",
                          },
                          on: { playing: _vm.playing },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm.post.media
                ? _c("div", { domProps: { innerHTML: _vm._s(_vm.post.media) } })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "c-post-click c-article__main o-grid__item u-width-full c-post__bottom",
        },
        [
          _c("div", { staticClass: "o-grid" }, [
            _c(
              "div",
              { staticClass: "o-grid__item u-width-2/12 u-width-full@s" },
              [_c("like-repost-comment")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "o-grid__item u-width-9/12 u-width-10/12@m u-width-full@s",
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      { name: "twitteremoji", rawName: "v-twitteremoji" },
                    ],
                    staticClass: "c-article__content c-article__content--ugc",
                  },
                  [
                    _c("div", {
                      attrs: { id: "content" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$simpleStore.highlightHashtags(
                            _vm.post.content,
                            _vm.post.community_url
                          )
                        ),
                      },
                    }),
                    _vm._v(" "),
                    typeof _vm.post.embeddedTweet != "undefined"
                      ? _c("div", { staticClass: "tweet" }, [
                          _c("div", { staticClass: "content" }, [
                            _c("div", { staticClass: "profile" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm.post.embeddedTweet.profile_image,
                                  alt: "profile image",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.post.embeddedTweet.link,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "@" + _vm._s(_vm.post.embeddedTweet.user)
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                                ·\n                                " +
                                  _vm._s(_vm.post.embeddedTweet.date) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.post.embeddedTweet.text),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _vm.post.embeddedTweet.media != null
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.post.embeddedTweet.link,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "media",
                                    attrs: {
                                      src: _vm.post.embeddedTweet.media.url,
                                      alt: "",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "c-article__share" },
                  [
                    _c("h5", [_vm._v("Share this post:")]),
                    _vm._v(" "),
                    _c("share-buttons"),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.post.enable_comments
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-article__comments u-border-b u-flex u-m-b3",
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "u-color-grey2 u-text-small u-p-b1",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "u-color-black u-text-normal u-bold",
                                },
                                [
                                  _vm.commentCount !== 1
                                    ? [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.commentCount) +
                                            " comments\n                                "
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.commentCount) +
                                            " comment\n                                "
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _vm._v(
                                "\n                            in the\n                            "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: { href: "/" + _vm.post.community_url },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$simpleStore.cloudinaryUrl(
                                        24,
                                        24,
                                        "img/communities/" +
                                          _vm.post.community_id +
                                          "/" +
                                          _vm.post.community_thumbnail,
                                        _vm.$root
                                      ),
                                      alt: _vm.post.community_name,
                                      width: "24",
                                      height: "24",
                                      alt: "community logo",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "u-color-black u-bold" },
                                    [_vm._v(_vm._s(_vm.post.community_name))]
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                            community\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("post-comments-block"),
                    ]
                  : _c("p", { staticClass: "clear u-p-b3" }, [
                      _vm._v("Comments are disabled for this post."),
                    ]),
                _vm._v(" "),
                _c("reposted-to"),
                _vm._v(" "),
                _c("related-communities"),
              ],
              2
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }